export default "__VITE_ASSET__vnQWCiQr__"